import { useRadioContext } from '../radio'
import { RadioLabelVariants } from '../radio.styles'
import type { RadioScopedProps, TRadioLabelProps } from '../radio.types'

export const RadioLabel = (props: RadioScopedProps<TRadioLabelProps>) => {
  const { children, __scopeRadio } = props
  const { disabled, readOnly, size } = useRadioContext(
    'RadioLabel',
    __scopeRadio
  )

  if (!children) return null

  return (
    <span
      className={RadioLabelVariants({
        disabled,
        readOnly,
        size,
      })}
    >
      {children}
    </span>
  )
}
